export const BATCH_REQUEST_SIZE = 15;

export const LOAD_ERROR_MESSAGE =
	'An error occured when trying to load job lines.';

export default {
	BATCH_REQUEST_SIZE,
	LOAD_ERROR_MESSAGE
};
